export function isObject(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

export function deepMerge<T extends Record<string, unknown>, U extends Record<string, unknown>>(
  target: T,
  source: U,
): T & U {
  const out: any = Array.isArray(target) ? [...(target as any)] : { ...target }
  if (!isObject(source)) return out
  for (const [key, val] of Object.entries(source)) {
    if (isObject(val) && isObject(out[key])) {
      out[key] = deepMerge(out[key] as Record<string, unknown>, val as Record<string, unknown>)
    } else {
      out[key] = val as any
    }
  }
  return out
}
